var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.72056 5.15337L3.21431 6.46854L2.14288 13.4328L9.10717 12.3614L10.4223 8.85515",
    stroke: "#673C8E",
    strokeWidth: 1.28571,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.14288 13.4328L5.6711 9.90462",
    stroke: "#673C8E",
    strokeWidth: 1.28571,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50021 2.71834L5.89294 4.32561L11.25 9.68265L12.8572 8.07538L7.50021 2.71834Z",
    stroke: "#673C8E",
    strokeWidth: 1.28571,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18609 9.90472C7.60451 9.4863 7.60451 8.80792 7.18609 8.3895C6.76768 7.97109 6.08929 7.97109 5.67088 8.3895C5.25246 8.80792 5.25246 9.4863 5.67088 9.90472C6.08929 10.3231 6.76768 10.3231 7.18609 9.90472Z",
    stroke: "#673C8E",
    strokeWidth: 1.28571,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteAccount);
export default __webpack_public_path__ + "static/media/deleteAccount.c446ae165732da746ba17b4a843f29c9.svg";
export { ForwardRef as ReactComponent };